import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { sleep } from './../utils'
import { useAuth } from '../hooks/Auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'


export default function Profile({ user }) {
  const auth = useAuth()
  const [username, setUsername] = useState(null)
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [password2, setPassword2] = useState(null)
  const [error, setError] = useState(null)
  const [result, setResult] = useState(null)

  const update = async () => {
    if (password !== password2) {
      setResult(null)
      setError('Passwords do not match')
    }
    else {
      try {
        await axios.patch('/api/users/me', {
          username: username,
          email: email,
          password: password
        })
        setError(null)
        setResult('Updated profile')
        await sleep(1000)
        auth.signout(()=> {})
      } catch (error) {
        const status = error.response.status
        setResult(null)
        if (status === 400 || status === 401 || status === 403)
          setError(error.response.data?.errors)
        else
          setError('Error updating profile')
      }
    }
  };

  useEffect(() => {
    if (user) {
      setUsername(user.username)
      setEmail(user.email)
    }
  }, [user])

  return (
    <div className="container-fluid mt-2">
      <div className="row">
        <div className="col card">
          <div className="card-header bg-transparent">
            <div className="row align-items-center">
              <div className="col">
                <h5 className="card-title text-uppercase text-muted mb-0">{user?.username}</h5>
                <span className="h2 font-weight-bold mb-0">Profile</span>
              </div>
            </div>
          </div>
          <div className="card-body pt-0 pb-1">
            <div className="row">
              <span className="text-danger pl-2">{error}</span>
              <span className="text-success pl-2">{result}</span>
            </div>
            <div className="row">
              <div className="col card">
                <div className="form-group mb-3">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FontAwesomeIcon className="pr-1" icon={faUser} /> Username:
                      </span>
                    </div>
                    <input type="text" className="form-control" value={username} placeholder="username" onChange={e => setUsername(e.target.value)}/>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FontAwesomeIcon className="pr-1" icon={faEnvelope} />Email:
                      </span>
                    </div>
                    <input type="email" className="form-control" value={email} placeholder="email" onChange={e => setEmail(e.target.value)}/>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FontAwesomeIcon className="pr-1" icon={faLock} />New password:
                      </span>
                    </div>
                    <input type="password" className="form-control" placeholder="*********" onChange={e => setPassword(e.target.value)}/>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">Repeat password:</span>
                    </div>
                    <input type="password" className="form-control" placeholder="*********" onChange={e => setPassword2(e.target.value)}/>
                  </div>
                </div>
                <div className="mb-3">
                  <span className="input-group-text">Role: {user?.role}</span>
                </div>
                <div className="mb-3">
                  <span className="input-group-text">Organisation: {user?.organisation}</span>
                </div>
                <hr/>
                <div>
                  <button onClick={update} className="btn btn-primary my-4">Update profile</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}